import { addDays, weekday } from './dates.js';
/**
 * Calendário de trabalho: converte datas em índices de dias úteis.
 * O índice cresce sob demanda; datas não úteis mapeiam para o próximo (idx) ou anterior (idxPrev) dia útil.
 */
export class WorkCalendar {
    workdays;
    holidays;
    base = null;
    days = [];
    index = new Map();
    constructor(cfg = {}) {
        this.workdays = new Set(cfg.workdays && cfg.workdays.length ? cfg.workdays : [1, 2, 3, 4, 5]);
        this.holidays = new Set(cfg.holidays ?? []);
        if (this.workdays.size === 0)
            throw new Error('Calendário sem dias úteis.');
    }
    isWork(d) { return this.workdays.has(weekday(d)) && !this.holidays.has(d); }
    ensure(from, to) {
        if (!this.base || from < this.base) {
            this.base = addDays(from, -400);
            this.days = [];
            this.index = new Map();
            this.extend(addDays(to, 1500));
            return;
        }
        const last = this.days[this.days.length - 1] ?? this.base;
        if (to > last)
            this.extend(addDays(to, 1500));
    }
    extend(to) {
        let d = this.days.length ? addDays(this.days[this.days.length - 1], 1) : this.base;
        for (let g = 0; d <= to && g < 60_000; g++) {
            if (this.isWork(d)) {
                this.index.set(d, this.days.length);
                this.days.push(d);
            }
            d = addDays(d, 1);
        }
    }
    /** índice do dia útil na data ou no próximo dia útil */
    idx(d) {
        this.ensure(d, d);
        let x = d;
        for (let g = 0; !this.index.has(x) && g < 400; g++)
            x = addDays(x, 1);
        return this.index.get(x) ?? 0;
    }
    /** índice do dia útil na data ou no dia útil anterior */
    idxPrev(d) {
        this.ensure(d, d);
        let x = d;
        for (let g = 0; !this.index.has(x) && g < 400; g++)
            x = addDays(x, -1);
        return this.index.get(x) ?? 0;
    }
    date(i) {
        const k = Math.max(0, i);
        while (k >= this.days.length)
            this.extend(addDays(this.days[this.days.length - 1], 2000));
        return this.days[k];
    }
    /** dias úteis entre a e b, inclusive */
    between(a, b) { return this.idxPrev(b) - this.idx(a) + 1; }
}
//# sourceMappingURL=calendar.js.map